export const contextDisplayName = (name: string | null | undefined) =>
  name?.trim() || "Unnamed Context";

export const buildDuplicateContextName = (name: string | null | undefined) =>
  `Copy of ${contextDisplayName(name)}`;
